import { useCallback, useEffect, useState } from 'react';

import { useStack9 } from '@april9au/stack9-react';
import { notification } from 'antd';

import { OSVehicleType } from '../../models/opensearch/inventory';
import { SearchResponse } from '../../models/opensearch/lib';

export const useOsVehicle = (
  input: { vin: string } | { vehicleId: string } | undefined,
) => {
  const [vehicle, setVehicle] = useState<OSVehicleType | null>(null);
  const { queryService } = useStack9();

  const fetchVehicle = useCallback(async () => {
    try {
      let match;
      let screenKey: 'vehicle_detail_by_vin' | 'vehicle_detail_by_vehicleId';
      if (input && 'vin' in input) {
        match = { 'vehicleDetails.vin': input.vin };
        screenKey = 'vehicle_detail_by_vin';
      } else if (input && 'vehicleId' in input) {
        match = { vehicleId: input.vehicleId };
        screenKey = 'vehicle_detail_by_vehicleId';
      } else {
        throw new Error('Either vin or vehicleId must be provided.');
      }

      const response = await queryService.runNamedQuery<
        SearchResponse<OSVehicleType>
      >(screenKey, 'searchOpensearchIndex', {
        vars: {
          page: 0,
          limit: 1,
          index_name: 'inventory',
          _source: [],
          query: JSON.stringify({ bool: { must: [{ match }] } }),
          aggs: JSON.stringify({}),
          sort: [],
          highlight: JSON.stringify({}),
        },
      });

      const vehicle = response?.data?.hits?.hits?.[0]?._source ?? null;
      if (vehicle) {
        setVehicle(vehicle);
      } else {
        throw new Error(
          'Vehicle could not be retrieved from Opensearch index.',
        );
      }
    } catch (e: any) {
      notification.error({
        message: `Error getting vehicle: ${e?.message || ''}`,
      });
    }
  }, [queryService, input]);

  useEffect(() => {
    fetchVehicle();
  }, [fetchVehicle]);

  return { vehicle };
};
